import { useIsGarageAdmin, useIsPortal } from 'utils/Subscription/PermissionSelector'
import { Subscriptions } from '@carsys/enums/subscription'
import { PERMISSION_GARAGE_ADMIN, PERMISSION_ONLY_PORTAL } from './Subscription/PermissionComposites'
import { hasPermission } from './Subscription/RequiredPermissions'
import { useGetCountryForPolicyURLS } from './use-get-country-for-policy'
import { useIsAuthenticated } from 'hooks/use-is-authenticated'
import useApplicatioName from './use-application-name'

interface IUrlsPerCountry {
  GB: string
  NL: string
  BE: string
  DE: string
  FR: string
}

interface IUrls {
  portal: IUrlsPerCountry
  gms: IUrlsPerCountry
  garageAdmin: IUrlsPerCountry
}

const urls: IUrls = {
  portal: {
    GB: 'https://carsys.s3.eu-central-1.amazonaws.com/public/documents/terms-and-conditions/portal/Terms.UK.pdf',
    NL: 'https://lkqeurope.nl/algemenevoorwaarden',
    BE: 'https://carsys.s3.eu-central-1.amazonaws.com/public/documents/terms-and-conditions/portal/Terms.BE.pdf',
    DE: 'https://carsys.s3.eu-central-1.amazonaws.com/public/documents/terms-and-conditions/portal/Terms.DE.pdf',
    FR: 'https://carsys.s3.eu-central-1.amazonaws.com/public/documents/terms-and-conditions/portal/Terms.FR.pdf'
  },
  gms: {
    GB: 'https://carsys.s3.eu-central-1.amazonaws.com/public/documents/terms-and-conditions/gms/Terms.UK.pdf',
    NL: 'https://carsys.s3.eu-central-1.amazonaws.com/public/documents/terms-and-conditions/gms/Terms.NL.pdf',
    BE: 'https://carsys.s3.eu-central-1.amazonaws.com/public/documents/terms-and-conditions/gms/Terms.BE.pdf',
    DE: 'https://carsys.s3.eu-central-1.amazonaws.com/public/documents/terms-and-conditions/gms/Terms.DE.pdf',
    FR: 'https://carsys.s3.eu-central-1.amazonaws.com/public/documents/terms-and-conditions/gms/Terms.FR.pdf'
  },
  garageAdmin: {
    GB: 'https://carsys.s3.eu-central-1.amazonaws.com/public/documents/terms-and-conditions/garageadmin/Terms.UK.pdf',
    NL: 'https://carsys.s3.eu-central-1.amazonaws.com/public/documents/terms-and-conditions/garageadmin/Terms.NL.pdf',
    BE: 'https://carsys.s3.eu-central-1.amazonaws.com/public/documents/terms-and-conditions/garageadmin/Terms.BE.pdf',
    DE: 'https://carsys.s3.eu-central-1.amazonaws.com/public/documents/terms-and-conditions/garageadmin/Terms.DE.pdf',
    FR: 'https://carsys.s3.eu-central-1.amazonaws.com/public/documents/terms-and-conditions/garageadmin/Terms.FR.pdf'
  }
}

export const useGetTermsAndConditionsUrl = () => {
  const isPortal = useIsPortal()
  const isGarageAdmin = useIsGarageAdmin()
  const country = useGetCountryForPolicyURLS()

  if (isPortal) return urls.portal[country]
  if (isGarageAdmin) return urls.garageAdmin[country]
  return urls.gms[country]
}

export const useGetTermsAndConditionsForCountryAndModules = (modules: Subscriptions[], country: string) => {
  const applicationName = useApplicatioName()
  const authenticated = useIsAuthenticated()
  const isPortal = hasPermission(modules, PERMISSION_ONLY_PORTAL, {})
  const isGarageAdmin = hasPermission(modules, PERMISSION_GARAGE_ADMIN, {})
  const c = country as keyof IUrlsPerCountry

  if (!authenticated) {
    switch (applicationName) {
      case 'carcat':
        return urls.portal[c]
      case 'carsys':
        return urls.gms[c]
    }
  }

  if (isPortal) return urls.portal[c]
  if (isGarageAdmin) return urls.garageAdmin[c]
  return urls.gms[c]
}
